// @ts-strict-ignore
import {Directions} from '../drop-menu/types';
import {Direction, PanelName} from './types';

// These default sizes correspond to the sidebar
// When resizing, allow the sidebar to "snap" to it's default width when falling within +/- this value
export const PANEL_RESIZE_SNAP_WINDOW = 12;
export const PANEL_MIN_WIDTH = 330;
export const PANEL_DEFAULT_WIDTH = 330;
export const PANEL_COLLAPSED_WIDTH = 60;
export const PANEL_MAX_WIDTH = 700;

export const SIDEBAR_DEFAULT_RATIO = 0.22;
export const DATA_TABLE_DEFAULT_RATIO = 0.5;

export const DATA_TABLE_MIN_HEIGHT = 220;
// min height of the chart area (above the data table panel) including padding
export const CHART_CONTAINER_MIN_HEIGHT = 276;
export const CHART_AND_TABLE_THRESHOLD_HEIGHT = 650;

// defines which suggested width is presented to the user by default
export const PANEL_MAX_AUTO_WIDTH = 560;

export const DEFAULT_PERSISTED_STATE = {
  alignment: undefined,
  isCollapsed: false,
  size: null,
};

export const KEYDOWN_EVENTS = {
  Meta: `Meta`,
  Ctrl: `Ctrl`,
  Backquote: `Backquote`,
  Backslash: `Backslash`,
  Digit1: `Digit1`,
};

export const KEYDOWN_EVENTS_CHARACTER = {
  Backquote: `\``,
  Backslash: `\\`,
  Digit1: `1`,
};

export const VERTICAL_DIRECTIONS = new Set<Direction>([Direction.Top, Direction.Bottom]);
export const HORIZONTAL_DIRECTIONS = new Set<Direction>([Direction.Left, Direction.Right]);
export const NEGATIVE_DIRECTIONS = new Set<Direction>([Direction.Left, Direction.Top]);

export const OPPOSITE_DIRECTION = {
  [Direction.Right]: Direction.Left,
  [Direction.Left]: Direction.Right,
  [Direction.Top]: Direction.Bottom,
  [Direction.Bottom]: Direction.Top,
};

export const ALIGN_DIRECTION_LABEL = {
  [Direction.Left]: ({t}) => t(`components.resizable-panel.align-left`),
  [Direction.Right]: ({t}) => t(`components.resizable-panel.align-right`),
  [Direction.Bottom]: ({t}) => t(`components.resizable-panel.align-bottom`),
  [Direction.Top]: ({t}) => t(`components.resizable-panel.align-top`),
};

export const COLLAPSE_LABEL = {
  [PanelName.Events]: ({t}) => t(`components.resizable-panel.collapse-events`),
  [PanelName.DataTable]: ({t}) => t(`components.resizable-panel.collapse-table`),
  [PanelName.Properties]: ({t}) => t(`components.resizable-panel.collapse-properties`),
  [PanelName.QueryPanel]: ({t}) => t(`components.resizable-panel.collapse-qb`),
  [PanelName.SideNav]: ({t}) => t(`components.resizable-panel.collapse-side-nav`),
  '': ({t}) => t(`components.resizable-panel.collapse`),
};

export const SHOW_LABEL = {
  [PanelName.Events]: ({t}) => t(`components.resizable-panel.show-events`),
  [PanelName.DataTable]: ({t}) => t(`components.resizable-panel.show-table`),
  [PanelName.Properties]: ({t}) => t(`components.resizable-panel.show-properties`),
  [PanelName.QueryPanel]: ({t}) => t(`components.resizable-panel.show-qb`),
  [PanelName.SideNav]: ({t}) => t(`components.resizable-panel.show-side-nav`),
  '': ({t}) => t(`components.resizable-panel.show`),
};

export const DROP_MENU_DIRECTION_MAPPING: {[d in Direction]: Directions} = {
  [Direction.Right]: Directions.Right,
  [Direction.Left]: Directions.Left,
  [Direction.Top]: Directions.Up,
  [Direction.Bottom]: Directions.Down,
};

export enum TrackingEvent {
  CollapsedPanel = `Collapsed Panel`,
  ExpandedPanel = `Expanded Panel`,
  ToggleAlignment = `Toggle Alignment`,
  ExtraActionClicked = `Extra Action Clicked`,
  Resize = `Resize`,
  Reset = `Reset Panel`,
  Reorder = `Reorder`,
}

export enum ResetPanelSource {
  DoubleClick = `Double Click`,
  SnapToDefault = `Snap to Default`,
}

export enum ExpandPanelSource {
  SwitchToFixedSize = `Switch to Fixed Size`,
}

export enum CollapsePanelSource {
  ResizedToEdge = `Resized to Edge`,
  ClickOutsideOverlay = `Click Outside Overlay`,
}

export enum OtherTogglePanelSource {
  Button = `Button`,
  KeyboardShortcut = `Keyboard Shortcut`,
}

export type TogglePanelSource = OtherTogglePanelSource | ExpandPanelSource | CollapsePanelSource;

export enum ToggleAlignmentSource {
  Button = `Button`,
}
